import { authSplitApi } from 'redux/helpers/slice.helpers';
import {
  ETagType,
  TTagDB,
  TTagUI,
  TTagsSliceProps,
} from 'data/types/tags.types';
import { ETagsUrls, getTagsListUrl } from 'data/urls/tags.url';
import {
  tagsEditConverter,
  tagsGetConverter,
} from 'data/convertors/tags.convertor';

const getTagEditUrl = (url: ETagsUrls) => {
  if (url === ETagsUrls.EVENT_REGISTRANT) return 'event-tags/registrant';
  if (url === ETagsUrls.EVENT_EVENT) return 'event-tags/event';
  return `${getTagsListUrl}/${url}`;
};

export const tagsApi = authSplitApi('tags', ['tags']).injectEndpoints({
  endpoints: build => ({
    getTagsList: build.query<TTagUI[], ETagType>({
      query(tagType) {
        return {
          url: getTagsListUrl,
          method: 'GET',
          params: {
            type: tagType,
          },
        };
      },
      transformResponse: (tags: TTagDB[]) => tagsGetConverter.fromDb(tags),
      providesTags: ['tags'],
      keepUnusedDataFor: 3600,
    }),
    editTags: build.mutation<void, TTagsSliceProps>({
      query(body) {
        return {
          url: getTagEditUrl(body.url),
          method: 'PATCH',
          body: tagsEditConverter.toDb(body),
        };
      },
      onQueryStarted(arg, { dispatch, queryFulfilled }) {
        queryFulfilled
          .then(() => {
            arg.invalidateTagsConfig.forEach(({ invalidateTag, sliceName }) => {
              dispatch(sliceName.util.invalidateTags([invalidateTag]));
            });
          })
          .catch(() => {
            // do nothing
          });
      },
    }),
  }),
});

export const { useGetTagsListQuery, useEditTagsMutation } = tagsApi;
